import React from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet'

export const Logo2025DefaultProps = {
  width: 135,
  height: 50,
}

export const Logo2025 = ({ width, height, ...rest }) => {
  return (
    <Box
      width={width + 'px'}
      height={height + 'px'}
      align={'end'}
      justify={'end'}
      {...rest}
    >
      <img
        alt={'Better Banking Logo'}
        src={'/images/icons/logos/transparent/white-logo-simple-transparent.png'}
        width={'100%'}
        height={'100%'}
      />
    </Box>
  )
}

Logo2025.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
}

Logo2025.defaultProps = Logo2025DefaultProps
